import { has, upperFirst } from "lodash";

import { mapActions, mapGetters, mapState } from "vuex";

export default {
  async created() {
    try {
      await Promise.all([
        this.attributeGetList({ reload: true }),
        this.entityGetList({ reload: false }),
      ]);
    } catch (e) {
      console.error(e);
      this.$notifyError({ message: "Unable to load data." });
    }
  },
  computed: {
    attributeListBase() {
      const { entityName } = this;

      return this.filterAttribute({ entityName }).sort(
        (a, b) => a.orderNumber - b.orderNumber
      );
    },
    attributeListFiltered() {
      const { mode } = this;

      const filteredList = this.attributeListBase
        .filter(attribute => !!attribute.elementType)
        .filter(attribute => !attribute[`exclude${upperFirst(mode)}`])
        .filter(attribute => {
          if (!this.organization || !this.organization.careSetting) {
            return false;
          }

          if (
            this.organization.careSetting === "Acute Care" &&
            has(attribute, "acute")
          ) {
            return !!attribute.acute;
          }

          if (
            this.organization.careSetting === "Ambulatory" &&
            has(attribute, "ambulatory")
          ) {
            return !!attribute.ambulatory;
          }
          return true;
        });

      return filteredList;
    },
    mode() {
      return "update";
    },
    organization() {
      return this.getOrganizationById(this.organizationId);
    },
    primaryKeyName() {
      const primaryKeyAttribute = this.attributeListBase.find(
        attribute => !!attribute.primaryKey
      );

      if (!primaryKeyAttribute) {
        throw new Error(
          `No primary key attribute found for ${this.entityName}`
        );
      }

      return primaryKeyAttribute.name;
    },
    ...mapGetters({
      filterAttribute: "attribute/filter",
      getOrganizationById: "organization/getById",
    }),
    ...mapState({
      organizationId: state => state.session.organizationId,
    }),
  },
  methods: {
    async entityGetList() {
      return this.$store.dispatch(`${this.entityName}/list`, {
        reload: false,
      });
    },
    ...mapActions({
      attributeGetList: "attribute/list",
    }),
  },
  props: {
    entityName: {
      required: true,
      type: String,
    },
  },
};
